// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fxjP","rootNoMargin":"styles_rootNoMargin__2vcws"};